import { useTheme } from '@mui/material/styles';
function NRCircleLowIcon({ height = '24', width = '24', color }) {
  const theme = useTheme();
  const iconColor = color || theme.palette.severityPalette[2].main;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill={iconColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7072 11.2929L15.293 9.87868L12.0001 13.1716L8.70718 9.87868L7.29297 11.2929L12.0001 16L16.7072 11.2929Z"
        fill={iconColor}
      />
    </svg>
  );
}

export default NRCircleLowIcon;
